// import React, { useState, useEffect } from "react";
// import {
//   Form,
//   Input,
//   Upload,
//   Button,
//   Row,
//   Col,
//   message,
//   Spin,
//   DatePicker,
// } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import { useLocation } from "react-router-dom";
// import axios from "../../api/axiosInstance";
// import App from "../../Utils/LayoutMobile";
// import JoditEditor from "jodit-react";
// import { useDispatch } from "react-redux";
// import { createLocation } from "../../features/locationSlice";
// import dayjs from "dayjs";

// const { RangePicker } = DatePicker;

// const MetadataForm = () => {
//   const [form] = Form.useForm();
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);

//   const [welcomeMessage, setWelcomeMessage] = useState("");
//   const [abstractMessage, setAbstractMessage] = useState("");
//   const [bannerFirst, setBannerFirst] = useState([]);
//   const [bannerSecound, setBannerSecound] = useState([]);
//   const [locationData, setLocationData] = useState({});
//   const [metadata, setMetadata] = useState({});

//   const location = useLocation();
//   const path = location.pathname;

//   const isHeroSection = path === "/herosection";
//   const isWelcomeMessage = path === "/welcome-message";
//   const isAbstract = path === "/Abstract-message";

//   const normalizeFile = (e) => (Array.isArray(e) ? e : e?.fileList || []);

//   const populateFormFields = (data) => {
//     form.setFieldsValue({
//       seoKeyword: data.seoKeyword || "",
//       metaDescription: data.metaDescription || "",
//       doctorName: data.doctorName || "",
//       heroTitle: data.heroTitle || "",
//       nextHeroTitle: data.nextHeroTitle || "",
//       abstractSubmissionDeadline: data.abstractSubmissionDeadline
//         ? dayjs(data.abstractSubmissionDeadline)
//         : null,
//       doctorImg: data.doctorImg
//         ? [{ uid: "-1", name: "doctor.png", status: "done", url: data.doctorImg }]
//         : [],
//       uploadCertificate: data.uploadCertificate
//         ? [{ uid: "-2", name: "certificate.png", status: "done", url: data.uploadCertificate }]
//         : [],
//       logo: data.logo
//         ? [{ uid: "-3", name: "logo.png", status: "done", url: data.logo }]
//         : [],
//     });

//     if (isHeroSection) {
//       form.setFieldsValue({
//         title: data.title || "",
//         dateRange: [
//           data.startDate ? dayjs(data.startDate) : null,
//           data.endDate ? dayjs(data.endDate) : null,
//         ],
//       });

//       setBannerFirst(
//         data.bannerFirst
//           ? [{ uid: "-4", name: "banner1.png", status: "done", url: data.bannerFirst }]
//           : []
//       );
//       setBannerSecound(
//         data.bannerSecound
//           ? [{ uid: "-5", name: "banner2.png", status: "done", url: data.bannerSecound }]
//           : []
//       );
//     }

//     setWelcomeMessage(data.welcomeMessage || "");
//     setAbstractMessage(data.abstractContent || "");
//   };

//   const handleSubmit = async (values) => {
//     const [startDate, endDate] = values.dateRange || [];

//     const formData = new FormData();
//     formData.append("seoKeyword", values.seoKeyword || "");
//     formData.append("metaDescription", values.metaDescription || "");
//     formData.append("doctorName", values.doctorName || "");
//     formData.append("heroTitle", values.heroTitle || "");
//     formData.append("nextHeroTitle", values.nextHeroTitle || "");
//     formData.append("welcomeMessage", welcomeMessage);
//     formData.append("abstractContent", abstractMessage);

//     if (isHeroSection) {
//       formData.append("type", "herolocation");
//       formData.append("title", values.title || "");
//       formData.append("startDate", startDate ? startDate.format("YYYY-MM-DD") : "");
//       formData.append("endDate", endDate ? endDate.format("YYYY-MM-DD") : "");
//     }

//     if (isAbstract && values.abstractSubmissionDeadline) {
//       formData.append(
//         "abstractSubmissionDeadline",
//         values.abstractSubmissionDeadline.format("YYYY-MM-DD")
//       );
//     }

//     const imageFields = {
//       uploadCertificate: values.uploadCertificate,
//       logo: values.logo,
//       doctorImg: values.doctorImg,
//       bannerFirst,
//       bannerSecound,
//     };

//     Object.entries(imageFields).forEach(([key, fileList]) => {
//       const file = Array.isArray(fileList) ? fileList[0] : fileList;
//       if (file?.originFileObj) {
//         formData.append(key, file.originFileObj);
//       } else if (file?.url) {
//         formData.append(`${key}Url`, file.url);
//       }
//     });

//     setLoading(true);
//     try {
//       const res = await axios.post("/api/v1/metadata", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       const metadata = res?.data?.data;

//       let locationData = {};
//       if (isHeroSection) {
//         try {
//           locationData = await dispatch(createLocation(formData)).unwrap();
//         } catch (locationErr) {
//           console.error("❌ Location save failed:", locationErr);
//           message.warning("Metadata saved, but location update failed.");
//         }
//       }

//       const mergedData = { ...metadata, ...locationData };
//       populateFormFields(mergedData);
//       message.success("Changes saved successfully");
//     } catch (error) {
//       console.error("❌ Metadata save failed:", error);
//       message.error(error?.message || "Failed to save changes");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchMetadata = async () => {
//       try {
//         setLoading(true);
//         const [metaRes, locationRes] = await Promise.all([
//           axios.get("/api/v1/metadata"),
//           axios.get("/api/v1/locations?type=herolocation"),
//         ]);
//         const metadata = metaRes.data.data;
//         const locationData = locationRes.data.data || {};

//         const mergedData = isHeroSection ? { ...metadata, ...locationData } : metadata;

//         populateFormFields(mergedData);
//       } catch (error) {
//         console.error("❌ Fetch error:", error);
//         message.error("Failed to load form data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMetadata();
//   }, [isHeroSection, isAbstract]); // ✅ added isAbstract dependency

//   return (
//     <App>
//       <Spin spinning={loading}>
//         <Form
//           form={form}
//           layout="vertical"
//           onFinish={handleSubmit}
//           style={{ maxWidth: 1200, margin: "auto" }}
//         >
//           {(isHeroSection || (!isHeroSection && !isWelcomeMessage && !isAbstract)) && (
//             <>
//               <h2 style={{ marginBottom: 30 }}>Add Hero Section</h2>
//               <Row gutter={16}>
//                 <Col span={12}>
//                   <Form.Item name="heroTitle" label="Hero Title">
//                     <Input />
//                   </Form.Item>
//                 </Col>
//                 <Col span={12}>
//                   <Form.Item name="nextHeroTitle" label="Next Hero Title">
//                     <Input />
//                   </Form.Item>
//                 </Col>
//               </Row>

//               <Row gutter={16}>
//                 <Col span={12}>
//                   <Form.Item label="First Banner">
//                     <Upload
//                       listType="picture"
//                       fileList={bannerFirst}
//                       beforeUpload={() => false}
//                       onChange={({ fileList }) => setBannerFirst(fileList)}
//                     >
//                       <Button icon={<UploadOutlined />}>Upload Banner</Button>
//                     </Upload>
//                   </Form.Item>
//                 </Col>
//                 <Col span={12}>
//                   <Form.Item label="Second Banner">
//                     <Upload
//                       listType="picture"
//                       fileList={bannerSecound}
//                       beforeUpload={() => false}
//                       onChange={({ fileList }) => setBannerSecound(fileList)}
//                     >
//                       <Button icon={<UploadOutlined />}>Upload Banner</Button>
//                     </Upload>
//                   </Form.Item>
//                 </Col>
//               </Row>

//               <Row gutter={16}>
//                 <Col span={12}>
//                   <Form.Item name="title" label="Location Title">
//                     <Input />
//                   </Form.Item>
//                 </Col>
//                 <Col span={12}>
//                   <Form.Item
//                     name="dateRange"
//                     label="Date Range"
//                     rules={[{ required: true, message: "Please select date range" }]}
//                   >
//                     <RangePicker style={{ width: "100%" }} />
//                   </Form.Item>
//                 </Col>
//               </Row>
//             </>
//           )}

//           {!isHeroSection && !isWelcomeMessage && !isAbstract && (
//             <>
//               <Form.Item
//                 name="uploadCertificate"
//                 label="Upload Certificate"
//                 valuePropName="fileList"
//                 getValueFromEvent={normalizeFile}
//               >
//                 <Upload listType="text" beforeUpload={() => false}>
//                   <Button icon={<UploadOutlined />}>Select Certificate</Button>
//                 </Upload>
//               </Form.Item>

//               <Form.Item
//                 name="doctorImg"
//                 label="Doctor Image"
//                 valuePropName="fileList"
//                 getValueFromEvent={normalizeFile}
//               >
//                 <Upload listType="picture" beforeUpload={() => false}>
//                   <Button icon={<UploadOutlined />}>Upload Doctor Image</Button>
//                 </Upload>
//               </Form.Item>
//             </>
//           )}

//           {(isWelcomeMessage || (!isHeroSection && !isWelcomeMessage && !isAbstract)) && (
//             <>
//               <h2 style={{ marginBottom: 30 }}>Add Welcome Message</h2>
//               <Form.Item label="Welcome Message">
//                 <JoditEditor
//                   value={welcomeMessage}
//                   config={{ height: 300 }}
//                   onBlur={(newContent) => setWelcomeMessage(newContent)}
//                 />
//               </Form.Item>
//               <Row gutter={16}>
//                 <Col span={12}>
//                   <Form.Item name="doctorName" label="Doctor Name">
//                     <Input />
//                   </Form.Item>
//                 </Col>
//                 <Col span={12}>
//                   <Form.Item
//                     name="doctorImg"
//                     label="Doctor Image"
//                     valuePropName="fileList"
//                     getValueFromEvent={normalizeFile}
//                   >
//                     <Upload listType="picture" beforeUpload={() => false}>
//                       <Button icon={<UploadOutlined />}>Upload Doctor Image</Button>
//                     </Upload>
//                   </Form.Item>
//                 </Col>
//               </Row>
//             </>
//           )}

//           {isAbstract && (
//             <>
//               <Form.Item label="Abstract Message">
//                 <JoditEditor
//                   value={abstractMessage}
//                   config={{ height: 300 }}
//                   onBlur={(newContent) => setAbstractMessage(newContent)}
//                 />
//               </Form.Item>

//               <Form.Item
//                 name="abstractSubmissionDeadline"
//                 label="Abstract Submission Deadline"
//                 rules={[{ required: true, message: "Please select the deadline date!" }]}
//               >
//                 <DatePicker style={{ width: "50%" }} />
//               </Form.Item>
//             </>
//           )}

//           <Form.Item>
//             <Button type="primary" htmlType="submit">
//               Save
//             </Button>
//           </Form.Item>
//         </Form>
//       </Spin>
//     </App>
//   );
// };

// export default MetadataForm;
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../api/axiosInstance";
import App from "../../Utils/LayoutMobile";
import JoditEditor from "jodit-react";
import { useDispatch } from "react-redux";
import { createLocation } from "../../features/locationSlice";
import dayjs from "dayjs";

/* ─── Design tokens ─────────────────────────────────────── */
const C_PINK   = "#F04DA0";
const C_PURPLE = "#8B2FC9";
const C_DARK   = "#1a0040";
const C_GRAD   = `linear-gradient(135deg, ${C_PINK}, ${C_PURPLE})`;

/* ─── Icons for Marquee ─────────────────────────────────── */
const ICON_OPTIONS = [
  { 
    value: "megaphone", 
    svg: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></svg>
  },
  { 
    value: "star", 
    svg: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
  },
  { 
    value: "info", 
    svg: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
  },
  { 
    value: "alert", 
    svg: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
  }
];

const getIconSvg = (val) => ICON_OPTIONS.find(opt => opt.value === val)?.svg || ICON_OPTIONS[0].svg;

/* ─── Toast ─────────────────────────────────────────────── */
let _toastId = 0;
function useToast() {
  const [toasts, setToasts] = useState([]);
  const add = (msg, type = "success") => {
    const id = ++_toastId;
    setToasts(p => [...p, { id, msg, type }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), 3500);
  };
  return { toasts, success: m => add(m, "success"), error: m => add(m, "error"), warning: m => add(m, "warning") };
}

/* ─── File Upload Field ──────────────────────────────────── */
function UploadField({ label, accept = "image/*", fileList, onChange, hint }) {
  const inputRef = useRef();
  const file = fileList?.[0];

  const handleFiles = (files) => {
    if (!files?.length) return;
    const f = files[0];
    const preview = URL.createObjectURL(f);
    onChange([{ uid: Date.now(), name: f.name, status: "done", originFileObj: f, url: preview }]);
  };

  return (
    <div className="mf-field">
      {label && <label className="mf-label">{label}</label>}
      <div
        className={`mf-upload-zone ${file ? "mf-upload-zone--has-file" : ""}`}
        onClick={() => inputRef.current?.click()}
        onDragOver={e => { e.preventDefault(); e.currentTarget.classList.add("mf-upload-zone--drag"); }}
        onDragLeave={e => e.currentTarget.classList.remove("mf-upload-zone--drag")}
        onDrop={e => { e.preventDefault(); e.currentTarget.classList.remove("mf-upload-zone--drag"); handleFiles(e.dataTransfer.files); }}
      >
        <input ref={inputRef} type="file" accept={accept} style={{ display: "none" }}
          onChange={e => handleFiles(e.target.files)} />

        {file ? (
          <div className="mf-upload-preview">
            {file.url && accept.startsWith("image") ? (
              <img src={file.url} alt="preview" className="mf-preview-img" />
            ) : (
              <div className="mf-file-icon">
                <svg width="22" height="22" fill="none" stroke={C_PURPLE} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <path d="M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z"/>
                  <polyline points="14 2 14 8 20 8"/>
                </svg>
              </div>
            )}
            <div className="mf-upload-meta">
              <span className="mf-upload-name">{file.name}</span>
              <span className="mf-upload-change">Click to change</span>
            </div>
            <button type="button" className="mf-upload-remove" onClick={e => { e.stopPropagation(); onChange([]); }}>
              <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" viewBox="0 0 24 24">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
        ) : (
          <div className="mf-upload-placeholder">
            <div className="mf-upload-ico">
              <svg width="20" height="20" fill="none" stroke={C_PINK} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/>
                <path d="M20.39 18.39A5 5 0 0018 9h-1.26A8 8 0 103 16.3"/>
              </svg>
            </div>
            <span className="mf-upload-text">Drop file or <strong>click to browse</strong></span>
            {hint && <span className="mf-upload-hint">{hint}</span>}
          </div>
        )}
      </div>
    </div>
  );
}

/* ─── Date Input ─────────────────────────────────────────── */
function DateField({ label, value, onChange, required }) {
  return (
    <div className="mf-field">
      {label && <label className="mf-label">{label}{required && <span className="mf-required">*</span>}</label>}
      <div className="mf-date-wrap">
        <svg className="mf-date-ico" width="15" height="15" fill="none" stroke={C_PINK} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
        <input
          type="date"
          className="mf-input mf-input--date"
          value={value || ""}
          onChange={e => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}

/* ─── Date Range Field ───────────────────────────────────── */
function DateRangeField({ label, value = [], onChange, required }) {
  return (
    <div className="mf-field">
      {label && <label className="mf-label">{label}{required && <span className="mf-required">*</span>}</label>}
      <div className="mf-date-range">
        <div className="mf-date-wrap mf-date-wrap--range">
          <svg className="mf-date-ico" width="14" height="14" fill="none" stroke={C_PINK} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          <input type="date" className="mf-input mf-input--date" placeholder="Start date"
            value={value[0] || ""} onChange={e => onChange([e.target.value, value[1]])} />
        </div>
        <div className="mf-range-sep">
          <svg width="16" height="16" fill="none" stroke="#c4b4d8" strokeWidth="2" strokeLinecap="round" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </div>
        <div className="mf-date-wrap mf-date-wrap--range">
          <svg className="mf-date-ico" width="14" height="14" fill="none" stroke={C_PINK} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          <input type="date" className="mf-input mf-input--date" placeholder="End date"
            value={value[1] || ""} onChange={e => onChange([value[0], e.target.value])} />
        </div>
      </div>
    </div>
  );
}

/* ─── Section Card ───────────────────────────────────────── */
function SectionCard({ title, subtitle, icon, iconColor, iconBg, iconBorder, delay = 0, children }) {
  return (
    <div className="mf-section-card" style={{ animationDelay: `${delay}s` }}>
      <div className="mf-section-header">
        <span className="mf-section-icon" style={{ color: iconColor, background: iconBg, borderColor: iconBorder }}>
          {icon}
        </span>
        <div>
          <h2 className="mf-section-title">{title}</h2>
          {subtitle && <p className="mf-section-sub">{subtitle}</p>}
        </div>
      </div>
      <div className="mf-section-body">
        {children}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════ */
const MetadataForm = () => {
  const dispatch   = useDispatch();
  const location   = useLocation();
  const path       = location.pathname;
  const toast      = useToast();

  const isHeroSection    = path === "/herosection";
  const isWelcomeMessage = path === "/welcome-message";
  const isAbstract       = path === "/Abstract-message";

  const [loading, setLoading]   = useState(false);
  const [saving,  setSaving]    = useState(false);

  /* form fields */
  const [fields, setFields] = useState({
    heroTitle: "", nextHeroTitle: "", title: "",
    doctorName: "", seoKeyword: "", metaDescription: "",
    abstractSubmissionDeadline: "",
    dateRange: ["", ""],
  });
  const [welcomeMessage,  setWelcomeMessage]  = useState("");
  const [abstractMessage, setAbstractMessage] = useState("");
  const [bannerFirst,  setBannerFirst]  = useState([]);
  const [bannerSecond, setBannerSecond] = useState([]);
  const [doctorImg,       setDoctorImg]       = useState([]);
  const [uploadCertificate, setUploadCertificate] = useState([]);
  const [logo, setLogo] = useState([]);

  /* ─── Scrolling Text State ─── */
  const [scrollingTexts, setScrollingTexts] = useState([]);
  const [newScrollText, setNewScrollText] = useState({ text: "", icon: "megaphone" }); 
  const [addingScrollText, setAddingScrollText] = useState(false);

  const set = (key) => (val) => setFields(p => ({ ...p, [key]: val }));
  const setInput = (e) => setFields(p => ({ ...p, [e.target.name]: e.target.value }));

  /* populate */
  const populate = (data) => {
    setFields({
      heroTitle:    data.heroTitle    || "",
      nextHeroTitle:data.nextHeroTitle|| "",
      title:        data.title        || "",
      doctorName:   data.doctorName   || "",
      seoKeyword:   data.seoKeyword   || "",
      metaDescription: data.metaDescription || "",
      abstractSubmissionDeadline: data.abstractSubmissionDeadline
        ? dayjs(data.abstractSubmissionDeadline).format("YYYY-MM-DD") : "",
      dateRange: [
        data.startDate ? dayjs(data.startDate).format("YYYY-MM-DD") : "",
        data.endDate   ? dayjs(data.endDate).format("YYYY-MM-DD")   : "",
      ],
    });
    setWelcomeMessage(data.welcomeMessage || "");
    setAbstractMessage(data.abstractContent || "");
    if (data.bannerFirst)  setBannerFirst( [{ uid:"-4", name:"banner1.png",   status:"done", url:data.bannerFirst }]);
    if (data.bannerSecound)setBannerSecond([{ uid:"-5", name:"banner2.png",   status:"done", url:data.bannerSecound }]);
    if (data.doctorImg)    setDoctorImg(   [{ uid:"-1", name:"doctor.png",    status:"done", url:data.doctorImg }]);
    if (data.uploadCertificate) setUploadCertificate([{ uid:"-2", name:"certificate.png", status:"done", url:data.uploadCertificate }]);
    if (data.logo)         setLogo(        [{ uid:"-3", name:"logo.png",      status:"done", url:data.logo }]);
  };

  /* ─── Fetch Scrolling Texts ─── */
  const fetchScrollingTexts = async () => {
    try {
      const res = await axios.get("/api/v1/scrolling-text"); 
      if (res.data.success) setScrollingTexts(res.data.data);
    } catch (err) {
      console.error("Failed to fetch scrolling texts", err);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const [metaRes, locationRes] = await Promise.all([
          axios.get("/api/v1/metadata"),
          axios.get("/api/v1/locations?type=herolocation"),
        ]);
        
        if (isHeroSection || (!isHeroSection && !isWelcomeMessage && !isAbstract)) {
           await fetchScrollingTexts();
        }

        const meta     = metaRes.data.data;
        const locData  = locationRes.data.data || {};
        populate(isHeroSection ? { ...meta, ...locData } : meta);
      } catch {
        toast.error("Failed to load form data");
      } finally {
        setLoading(false);
      }
    })();
  }, [isHeroSection, isAbstract, isWelcomeMessage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();

    fd.append("seoKeyword",       fields.seoKeyword);
    fd.append("metaDescription",  fields.metaDescription);
    fd.append("doctorName",       fields.doctorName);
    fd.append("heroTitle",        fields.heroTitle);
    fd.append("nextHeroTitle",    fields.nextHeroTitle);
    fd.append("welcomeMessage",   welcomeMessage);
    fd.append("abstractContent",  abstractMessage);

    if (isHeroSection) {
      fd.append("type",      "herolocation");
      fd.append("title",     fields.title);
      fd.append("startDate", fields.dateRange[0]);
      fd.append("endDate",   fields.dateRange[1]);
    }
    if (isAbstract && fields.abstractSubmissionDeadline) {
      fd.append("abstractSubmissionDeadline", fields.abstractSubmissionDeadline);
    }

    const imgFields = { uploadCertificate, logo, doctorImg, bannerFirst, bannerSecond };
    Object.entries(imgFields).forEach(([key, fileList]) => {
      const file = fileList?.[0];
      if (file?.originFileObj) fd.append(key, file.originFileObj);
      else if (file?.url)      fd.append(`${key}Url`, file.url);
    });

    setSaving(true);
    try {
      const res = await axios.post("/api/v1/metadata", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      let merged = res?.data?.data || {};
      if (isHeroSection) {
        try {
          const locData = await dispatch(createLocation(fd)).unwrap();
          merged = { ...merged, ...locData };
        } catch {
          toast.warning("Metadata saved, but location update failed.");
        }
      }
      populate(merged);
      toast.success("Changes saved successfully!");
    } catch (err) {
      toast.error(err?.message || "Failed to save changes");
    } finally {
      setSaving(false);
    }
  };

  /* ─── Scrolling Text Handlers ─── */
  const handleAddScrollText = async () => {
    if (!newScrollText.text.trim()) return toast.warning("Text content is required!");
    setAddingScrollText(true);
    try {
      const res = await axios.post("/api/v1/scrolling-text", newScrollText);
      if (res.data.success) {
        setScrollingTexts([res.data.data, ...scrollingTexts]);
        setNewScrollText({ text: "", icon: "megaphone" }); // Reset text and icon
        toast.success("Announcement added successfully!");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to add announcement");
    } finally {
      setAddingScrollText(false);
    }
  };

  const handleToggleScrollText = async (id, currentStatus) => {
    try {
      const res = await axios.put(`/api/v1/scrolling-text/${id}`, { isActive: !currentStatus });
      if (res.data.success) {
        setScrollingTexts(scrollingTexts.map(t => t._id === id ? { ...t, isActive: !currentStatus } : t));
        toast.success(`Announcement ${!currentStatus ? 'activated' : 'hidden'}`);
      }
    } catch (err) {
      toast.error("Failed to update status");
    }
  };

  const handleDeleteScrollText = async (id) => {
    if (!window.confirm("Are you sure you want to delete this announcement?")) return;
    try {
      const res = await axios.delete(`/api/v1/scrolling-text/${id}`);
      if (res.data.success) {
        setScrollingTexts(scrollingTexts.filter(t => t._id !== id));
        toast.success("Announcement deleted!");
      }
    } catch (err) {
      toast.error("Failed to delete announcement");
    }
  };

  /* ── Icon SVGs ── */
  const HeroIcon = (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>
  );
  const WelcomeIcon = (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
  );
  const AbstractIcon = (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/></svg>
  );
  const MarqueeIcon = (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="10" rx="2" ry="2" /><polyline points="8 12 12 12 16 12" /><path d="M16 10l2 2-2 2" /></svg>
  );
  const SaveIcon = (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
  );

  /* ── Page title logic ── */
  const pageTitle = isHeroSection ? "Hero Section" : isWelcomeMessage ? "Welcome Message" : isAbstract ? "Abstract Message" : "Site Settings";
  const pageSub   = isHeroSection ? "Configure the main landing section and event banners."
    : isWelcomeMessage ? "Craft the welcome message from your lead doctor."
    : isAbstract ? "Set the abstract submission content and deadline."
    : "Manage all site metadata and content sections.";

  return (
    <App>
      <div className="mf-page">

        {/* ── Toast container ── */}
        <div className="mf-toast-container">
          {toast.toasts.map(t => (
            <div key={t.id} className={`mf-toast mf-toast--${t.type}`}>
              {t.type === "success" && <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>}
              {t.type === "error"   && <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>}
              {t.type === "warning" && <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>}
              <span>{t.msg}</span>
            </div>
          ))}
        </div>

        {/* ── Page header ── */}
        <div className="mf-page-header">
          <div className="mf-eyebrow">
            <span className="mf-eyebrow-dot" />
            Admin Panel
          </div>
          <h1 className="mf-page-title">
            {pageTitle} <span className="mf-grad">Settings</span>
          </h1>
          <p className="mf-page-sub">{pageSub}</p>
        </div>

        {/* ── Loading overlay ── */}
        {loading && (
          <div className="mf-loading">
            <div className="mf-spinner" />
            <span>Loading content…</span>
          </div>
        )}

        {!loading && (
          <form onSubmit={handleSubmit} className="mf-form">

            {/* ══ HERO SECTION ══ */}
            {(isHeroSection || (!isHeroSection && !isWelcomeMessage && !isAbstract)) && (
              <SectionCard
                title="Hero Section"
                subtitle="Configure the main banner titles and event date range"
                icon={HeroIcon}
                iconColor={C_PINK}
                iconBg="rgba(240,77,160,0.1)"
                iconBorder="rgba(240,77,160,0.2)"
                delay={0.05}
              >
                <div className="mf-grid-2">
                  <div className="mf-field">
                    <label className="mf-label">Hero Title</label>
                    <input className="mf-input" type="text" name="heroTitle"
                      placeholder="e.g. Skinola International Aesthetics"
                      value={fields.heroTitle} onChange={setInput} />
                  </div>
                  <div className="mf-field">
                    <label className="mf-label">Next Hero Title</label>
                    <input className="mf-input" type="text" name="nextHeroTitle"
                      placeholder="e.g. 2025 Edition"
                      value={fields.nextHeroTitle} onChange={setInput} />
                  </div>
                </div>

                <div className="mf-grid-2">
                  <UploadField
                    label="First Banner"
                    hint="Recommended: 1920×600px"
                    fileList={bannerFirst}
                    onChange={setBannerFirst}
                  />
                  <UploadField
                    label="Second Banner"
                    hint="Recommended: 1920×600px"
                    fileList={bannerSecond}
                    onChange={setBannerSecond}
                  />
                </div>

                <div className="mf-grid-2">
                  <div className="mf-field">
                    <label className="mf-label">Location Title</label>
                    <div className="mf-input-icon-wrap">
                      <svg className="mf-input-icon" width="15" height="15" fill="none" stroke={C_PINK} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                      </svg>
                      <input className="mf-input mf-input--icon" type="text" name="title"
                        placeholder="e.g. Mumbai Convention Centre"
                        value={fields.title} onChange={setInput} />
                    </div>
                  </div>
                  <DateRangeField
                    label="Event Date Range"
                    required
                    value={fields.dateRange}
                    onChange={set("dateRange")}
                  />
                </div>
              </SectionCard>
            )}

            {/* ══ CERTIFICATE & DOCTOR IMAGE (non-section pages) ══ */}
            {!isHeroSection && !isWelcomeMessage && !isAbstract && (
              <SectionCard
                title="Media Assets"
                subtitle="Upload certificates, logos, and doctor images"
                icon={
                  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                    <circle cx="8.5" cy="8.5" r="1.5"/>
                    <polyline points="21 15 16 10 5 21"/>
                  </svg>
                }
                iconColor={C_PURPLE}
                iconBg="rgba(139,47,201,0.1)"
                iconBorder="rgba(139,47,201,0.2)"
                delay={0.1}
              >
                <div className="mf-grid-2">
                  <UploadField
                    label="Upload Certificate"
                    hint="PDF or image format"
                    accept=".pdf,image/*"
                    fileList={uploadCertificate}
                    onChange={setUploadCertificate}
                  />
                  <UploadField
                    label="Doctor Image"
                    hint="PNG or JPG, min 400×400px"
                    fileList={doctorImg}
                    onChange={setDoctorImg}
                  />
                </div>
              </SectionCard>
            )}

            {/* ══ WELCOME MESSAGE ══ */}
            {(isWelcomeMessage || (!isHeroSection && !isWelcomeMessage && !isAbstract)) && (
              <SectionCard
                title="Welcome Message"
                subtitle="Compose the welcome note from your lead doctor"
                icon={WelcomeIcon}
                iconColor={C_PINK}
                iconBg="rgba(240,77,160,0.1)"
                iconBorder="rgba(240,77,160,0.2)"
                delay={0.1}
              >
                <div className="mf-field mf-field--full">
                  <label className="mf-label">Message Content</label>
                  <div className="mf-editor-wrap">
                    <JoditEditor
                      value={welcomeMessage}
                      config={{ height: 300, toolbar: true }}
                      onBlur={(newContent) => setWelcomeMessage(newContent)}
                    />
                  </div>
                </div>

                <div className="mf-grid-2" style={{ marginTop: 20 }}>
                  <div className="mf-field">
                    <label className="mf-label">Doctor Name</label>
                    <div className="mf-input-icon-wrap">
                      <svg className="mf-input-icon" width="15" height="15" fill="none" stroke={C_PINK} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
                      </svg>
                      <input className="mf-input mf-input--icon" type="text" name="doctorName"
                        placeholder="e.g. Dr. Priya Sharma"
                        value={fields.doctorName} onChange={setInput} />
                    </div>
                  </div>
                  <UploadField
                    label="Doctor Image"
                    hint="PNG or JPG, min 400×400px"
                    fileList={doctorImg}
                    onChange={setDoctorImg}
                  />
                </div>
              </SectionCard>
            )}

            {/* ══ ABSTRACT MESSAGE ══ */}
            {isAbstract && (
              <SectionCard
                title="Abstract Message"
                subtitle="Set the abstract call-to-action content and submission deadline"
                icon={AbstractIcon}
                iconColor={C_PURPLE}
                iconBg="rgba(139,47,201,0.1)"
                iconBorder="rgba(139,47,201,0.2)"
                delay={0.05}
              >
                <div className="mf-field mf-field--full">
                  <label className="mf-label">Abstract Content</label>
                  <div className="mf-editor-wrap">
                    <JoditEditor
                      value={abstractMessage}
                      config={{ height: 300 }}
                      onBlur={(newContent) => setAbstractMessage(newContent)}
                    />
                  </div>
                </div>

                <div className="mf-grid-2" style={{ marginTop: 20 }}>
                  <DateField
                    label="Abstract Submission Deadline"
                    required
                    value={fields.abstractSubmissionDeadline}
                    onChange={set("abstractSubmissionDeadline")}
                  />
                  <div className="mf-deadline-info">
                    <div className="mf-info-icon">
                      <svg width="16" height="16" fill="none" stroke={C_PURPLE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                      </svg>
                    </div>
                    <p className="mf-info-text">
                      The deadline will be shown publicly on the registration page. Authors will not be able to submit after this date.
                    </p>
                  </div>
                </div>
              </SectionCard>
            )}

            {/* ══ SCROLLING TEXT / ANNOUNCEMENTS SECTION ══ */}
            {(isHeroSection || (!isHeroSection && !isWelcomeMessage && !isAbstract)) && (
              <SectionCard
                title="Scrolling Announcements"
                subtitle="Manage dynamic scrolling text visible on the hero section."
                icon={MarqueeIcon}
                iconColor="#f59e0b"
                iconBg="rgba(245, 158, 11, 0.1)"
                iconBorder="rgba(245, 158, 11, 0.2)"
                delay={0.15}
              >
                {/* Add New Scroll Text Form */}
                <div className="mf-marquee-add" style={{ flexDirection: 'column' }}>
                  <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', width: '100%' }}>
                    <div className="mf-field" style={{ flex: 1 }}>
                      <label className="mf-label">Announcement Text *</label>
                      <input className="mf-input" type="text" 
                        placeholder="e.g. Early bird registrations close on 15th April!"
                        value={newScrollText.text} 
                        onChange={(e) => setNewScrollText(p => ({ ...p, text: e.target.value }))} 
                      />
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', width: '100%', flexWrap: 'wrap', gap: '14px' }}>
                    <div className="mf-field">
                      <label className="mf-label">Choose Icon</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        {ICON_OPTIONS.map((opt) => (
                          <button 
                            key={opt.value}
                            type="button" 
                            title={opt.value}
                            onClick={() => setNewScrollText(p => ({ ...p, icon: opt.value }))}
                            style={{
                              width: '40px', height: '40px', borderRadius: '8px', cursor: 'pointer',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              border: newScrollText.icon === opt.value ? `2px solid ${C_PINK}` : '1px solid #d8c8f0',
                              background: newScrollText.icon === opt.value ? '#ffe0f2' : '#fff',
                              color: newScrollText.icon === opt.value ? C_PINK : '#8a7a9a',
                              transition: 'all 0.2s'
                            }}
                          >
                            {opt.svg}
                          </button>
                        ))}
                      </div>
                    </div>
                    
                    <button type="button" className="mf-btn-secondary" disabled={addingScrollText} onClick={handleAddScrollText} style={{ height: '44px' }}>
                       {addingScrollText ? "Adding..." : "+ Add Announcement"}
                    </button>
                  </div>
                </div>

                {/* List of Existing Announcements */}
                <div className="mf-marquee-list">
                  {scrollingTexts.length === 0 ? (
                    <p className="mf-empty-state">No announcements added yet.</p>
                  ) : (
                    scrollingTexts.map((item) => (
                      <div key={item._id} className={`mf-marquee-item ${!item.isActive ? 'mf-marquee-inactive' : ''}`}>
                        <div className="mf-marquee-content" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'row' }}>
                          <span style={{ color: item.isActive ? C_PINK : '#9a86b8', display: 'flex' }}>
                            {getIconSvg(item.icon)}
                          </span>
                          <strong>{item.text}</strong>
                        </div>
                        <div className="mf-marquee-actions">
                          <button type="button" className={`mf-btn-toggle ${item.isActive ? 'mf-toggle-active' : ''}`} onClick={() => handleToggleScrollText(item._id, item.isActive)}>
                            {item.isActive ? "Hide" : "Show"}
                          </button>
                          <button type="button" className="mf-btn-delete" onClick={() => handleDeleteScrollText(item._id)}>
                            Delete
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </SectionCard>
            )}

            {/* ══ SUBMIT BAR ══ */}
            <div className="mf-submit-bar">
              <div className="mf-submit-info">
                <svg width="14" height="14" fill="none" stroke="#9a86b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                All changes (excluding announcements) are saved to the live site when you click Save.
              </div>
              <button type="submit" className="mf-save-btn" disabled={saving}>
                {saving ? (
                  <>
                    <span className="mf-btn-spinner" />
                    <span>Saving…</span>
                  </>
                ) : (
                  <>
                    {SaveIcon}
                    <span>Save Changes</span>
                  </>
                )}
              </button>
            </div>

          </form>
        )}
      </div>

      <style>{`
        @keyframes mf-fadeUp {
          from { opacity:0; transform:translateY(14px) }
          to   { opacity:1; transform:translateY(0) }
        }
        @keyframes mf-pulse {
          0%,100% { opacity:1 } 50% { opacity:0.35 }
        }
        @keyframes mf-spin {
          to { transform:rotate(360deg) }
        }
        @keyframes mf-toast-in {
          from { opacity:0; transform:translateX(32px) }
          to   { opacity:1; transform:translateX(0) }
        }

        *,*::before,*::after { box-sizing:border-box }

        /* ── Page ── */
        .mf-page {
          background:#f4eefa;
          min-height:100vh;
          padding:28px 32px 72px;
          display:flex;flex-direction:column;gap:24px;
          font-family:inherit;
          position:relative;
        }

        /* ── Page header ── */
        .mf-page-header { animation:mf-fadeUp .4s ease both; }
        .mf-eyebrow {
          display:inline-flex;align-items:center;gap:7px;
          font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;
          color:${C_PINK};background:rgba(240,77,160,0.08);
          border:1px solid rgba(240,77,160,0.2);
          padding:5px 14px 5px 10px;border-radius:50px;margin-bottom:12px;
        }
        .mf-eyebrow-dot {
          width:6px;height:6px;border-radius:50%;background:${C_PINK};
          animation:mf-pulse 2s infinite;flex-shrink:0;
        }
        .mf-page-title {
          font-size:clamp(22px,2.5vw,30px);font-weight:800;color:${C_DARK};
          letter-spacing:-.025em;margin:0 0 6px;
        }
        .mf-grad {
          background:linear-gradient(90deg,${C_PINK},#c066f0);
          -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
        }
        .mf-page-sub { font-size:13.5px;color:#8a7a9a;margin:0; }

        /* ── Loading ── */
        .mf-loading {
          display:flex;align-items:center;gap:12px;
          padding:48px;justify-content:center;
          color:#8a7a9a;font-size:14px;font-weight:600;
        }
        .mf-spinner {
          width:28px;height:28px;border-radius:50%;
          border:3px solid rgba(240,77,160,0.15);
          border-top-color:${C_PINK};
          animation:mf-spin .75s linear infinite;
        }

        /* ── Form ── */
        .mf-form { display:flex;flex-direction:column;gap:20px; }

        /* ── Section card ── */
        .mf-section-card {
          background:#fff;border-radius:20px;
          border:1px solid #ede5f5;
          box-shadow:0 4px 20px rgba(26,0,64,.06);
          overflow:hidden;
          animation:mf-fadeUp .4s ease both;
        }
        .mf-section-header {
          display:flex;align-items:center;gap:14px;
          padding:20px 26px 18px;
          border-bottom:1px solid #f3ecfa;
          background:#faf6fe;
        }
        .mf-section-icon {
          width:44px;height:44px;border-radius:12px;flex-shrink:0;
          display:flex;align-items:center;justify-content:center;
          border:1px solid;
        }
        .mf-section-title { font-size:16px;font-weight:800;color:${C_DARK};margin:0 0 2px; }
        .mf-section-sub   { font-size:12px;color:#9a86b8;margin:0; }
        .mf-section-body  { padding:24px 26px 28px;display:flex;flex-direction:column;gap:20px; }

        /* ── Grid ── */
        .mf-grid-2 { display:grid;grid-template-columns:1fr 1fr;gap:20px; }

        /* ── Fields ── */
        .mf-field { display:flex;flex-direction:column;gap:7px; }
        .mf-field--full { grid-column:1/-1; }
        .mf-label {
          font-size:12px;font-weight:700;color:#5a5070;letter-spacing:.03em;
        }
        .mf-required { color:${C_PINK};margin-left:2px; }

        /* ── Input ── */
        .mf-input {
          height:44px;border-radius:11px;
          border:1.5px solid #e8d8f8;
          padding:0 14px;
          font-size:13.5px;color:${C_DARK};
          background:#fdfbff;
          transition:border-color .2s,box-shadow .2s;
          outline:none;font-family:inherit;width:100%;
        }
        .mf-input:focus {
          border-color:${C_PINK};
          box-shadow:0 0 0 3px rgba(240,77,160,0.12);
          background:#fff;
        }
        .mf-input::placeholder { color:#c4b4d8;font-size:13px; }

        .mf-input-icon-wrap { position:relative; }
        .mf-input-icon {
          position:absolute;left:13px;top:50%;transform:translateY(-50%);
          pointer-events:none;flex-shrink:0;
        }
        .mf-input--icon { padding-left:38px; }

        /* ── Date ── */
        .mf-date-wrap { position:relative; }
        .mf-date-wrap--range { flex:1; }
        .mf-date-ico {
          position:absolute;left:13px;top:50%;transform:translateY(-50%);
          pointer-events:none;
        }
        .mf-input--date {
          padding-left:38px;
          cursor:pointer;
        }
        .mf-input--date::-webkit-calendar-picker-indicator {
          opacity:.5;cursor:pointer;
        }
        .mf-date-range { display:flex;align-items:center;gap:10px; }
        .mf-range-sep  { flex-shrink:0;display:flex;align-items:center; }

        /* ── Upload zone ── */
        .mf-upload-zone {
          border:1.5px dashed #d8c8f0;
          border-radius:12px;
          background:#fdfbff;
          padding:18px 16px;
          cursor:pointer;
          transition:border-color .2s,background .2s,box-shadow .2s;
          position:relative;
          min-height:80px;
          display:flex;align-items:center;
        }
        .mf-upload-zone:hover,
        .mf-upload-zone--drag {
          border-color:${C_PINK};
          background:rgba(240,77,160,0.03);
          box-shadow:0 0 0 3px rgba(240,77,160,0.1);
        }
        .mf-upload-zone--has-file {
          border-style:solid;
          border-color:#e8d8f8;
          background:#fff;
        }

        .mf-upload-placeholder {
          display:flex;flex-direction:column;align-items:center;justify-content:center;
          gap:8px;width:100%;text-align:center;
        }
        .mf-upload-ico {
          width:42px;height:42px;border-radius:10px;
          background:rgba(240,77,160,0.08);
          display:flex;align-items:center;justify-content:center;
        }
        .mf-upload-text {
          font-size:12.5px;color:#8a7a9a;
        }
        .mf-upload-text strong { color:${C_PINK}; }
        .mf-upload-hint { font-size:11px;color:#b4a4c8; }

        .mf-upload-preview {
          display:flex;align-items:center;gap:14px;width:100%;
        }
        .mf-preview-img {
          width:52px;height:52px;object-fit:cover;
          border-radius:8px;border:1px solid #ede5f5;flex-shrink:0;
        }
        .mf-file-icon {
          width:52px;height:52px;border-radius:8px;
          background:rgba(139,47,201,0.08);
          display:flex;align-items:center;justify-content:center;flex-shrink:0;
        }
        .mf-upload-meta { flex:1;min-width:0; }
        .mf-upload-name {
          display:block;font-size:13px;font-weight:700;color:${C_DARK};
          overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
        }
        .mf-upload-change { font-size:11px;color:#9a86b8;margin-top:2px;display:block; }
        .mf-upload-remove {
          width:28px;height:28px;border-radius:7px;flex-shrink:0;
          border:1.5px solid #ffd0ea;background:#fff0f8;
          display:flex;align-items:center;justify-content:center;
          cursor:pointer;color:#F04DA0;
          transition:background .2s,border-color .2s;
        }
        .mf-upload-remove:hover { background:#ffe0f2;border-color:${C_PINK}; }

        /* ── Editor ── */
        .mf-editor-wrap {
          border-radius:12px;overflow:hidden;
          border:1.5px solid #e8d8f8;
          transition:border-color .2s,box-shadow .2s;
        }
        .mf-editor-wrap:focus-within {
          border-color:${C_PINK};
          box-shadow:0 0 0 3px rgba(240,77,160,0.12);
        }

        /* ── Deadline info ── */
        .mf-deadline-info {
          display:flex;align-items:flex-start;gap:12px;
          background:rgba(139,47,201,0.05);
          border:1px solid rgba(139,47,201,0.15);
          border-radius:12px;padding:16px;
          margin-top:auto;align-self:flex-end;
        }
        .mf-info-icon {
          width:32px;height:32px;border-radius:8px;flex-shrink:0;
          background:rgba(139,47,201,0.1);
          display:flex;align-items:center;justify-content:center;
        }
        .mf-info-text { font-size:12.5px;color:#6a5a7a;line-height:1.6;margin:0; }

        /* ── Scrolling Text Marquee ── */
        .mf-marquee-add {
          display:flex; gap: 14px; flex-wrap: wrap; margin-bottom: 24px;
          padding: 16px; background: #faf8fc; border-radius: 12px; border: 1px dashed #d8c8f0;
        }
        .mf-marquee-list {
          display:flex; flex-direction:column; gap: 12px;
        }
        .mf-empty-state {
          font-size: 13px; color: #9a86b8; text-align: center; padding: 10px 0;
        }
        .mf-marquee-item {
          display: flex; justify-content: space-between; align-items: center; gap: 14px;
          padding: 14px 18px; border: 1px solid #e8d8f8; border-radius: 12px; background: #fff;
          transition: opacity 0.2s;
        }
        .mf-marquee-inactive {
          opacity: 0.55; background: #fdfbff; border-style: dashed;
        }
        .mf-marquee-content {
          display: flex; flex-direction: column; gap: 4px;
        }
        .mf-marquee-content strong {
          font-size: 14px; color: ${C_DARK}; font-weight: 600;
        }
        .mf-marquee-actions {
          display: flex; gap: 8px; flex-shrink: 0;
        }
        .mf-btn-secondary {
          background: #fff; border: 1.5px solid #d8c8f0; border-radius: 11px;
          padding: 0 16px; font-size: 13px; font-weight: 600; color: ${C_PURPLE}; cursor: pointer;
          transition: all 0.2s; white-space: nowrap;
        }
        .mf-btn-secondary:hover { border-color: ${C_PURPLE}; background: rgba(139,47,201,0.04); }
        .mf-btn-toggle {
          background: #f1f5f9; border: 1px solid #cbd5e1; border-radius: 8px;
          padding: 6px 12px; font-size: 12px; font-weight: 600; color: #475569; cursor: pointer;
        }
        .mf-toggle-active {
          background: #dcfce7; border-color: #86efac; color: #166534;
        }
        .mf-btn-delete {
          background: #fee2e2; border: 1px solid #fca5a5; border-radius: 8px;
          padding: 6px 12px; font-size: 12px; font-weight: 600; color: #991b1b; cursor: pointer;
        }
        .mf-btn-delete:hover { background: #fecaca; }


        /* ── Submit bar ── */
        .mf-submit-bar {
          display:flex;align-items:center;justify-content:space-between;
          background:#fff;border-radius:16px;
          border:1px solid #ede5f5;
          box-shadow:0 4px 20px rgba(26,0,64,.06);
          padding:18px 26px;
          animation:mf-fadeUp .4s ease .2s both;
          gap:16px;flex-wrap:wrap;
        }
        .mf-submit-info {
          display:flex;align-items:center;gap:8px;
          font-size:12.5px;color:#9a86b8;font-weight:500;
        }

        .mf-save-btn {
          display:inline-flex;align-items:center;gap:10px;
          padding:13px 32px;
          background:${C_GRAD};
          color:#fff;font-size:14px;font-weight:700;
          border:none;border-radius:12px;cursor:pointer;
          box-shadow:0 8px 24px rgba(240,77,160,0.3);
          transition:transform .25s cubic-bezier(.16,1,.3,1),box-shadow .25s,opacity .2s;
          letter-spacing:.02em;font-family:inherit;
          position:relative;overflow:hidden;
          white-space:nowrap;
        }
        .mf-save-btn::before {
          content:"";position:absolute;inset:0;
          background:linear-gradient(135deg,${C_PURPLE},${C_PINK});
          opacity:0;transition:opacity .3s;
        }
        .mf-save-btn:hover:not(:disabled) {
          transform:translateY(-2px);
          box-shadow:0 14px 32px rgba(240,77,160,0.42);
        }
        .mf-save-btn:hover:not(:disabled)::before { opacity:1; }
        .mf-save-btn:disabled { opacity:.65;cursor:not-allowed; }
        .mf-save-btn span, .mf-save-btn svg { position:relative;z-index:1; }

        .mf-btn-spinner {
          width:16px;height:16px;border-radius:50%;
          border:2px solid rgba(255,255,255,0.3);
          border-top-color:#fff;
          animation:mf-spin .7s linear infinite;
          position:relative;z-index:1;
        }

        /* ── Toasts ── */
        .mf-toast-container {
          position:fixed;top:20px;right:20px;z-index:9999;
          display:flex;flex-direction:column;gap:8px;
          pointer-events:none;
        }
        .mf-toast {
          display:inline-flex;align-items:center;gap:9px;
          padding:12px 18px;border-radius:12px;
          font-size:13px;font-weight:600;
          box-shadow:0 8px 24px rgba(26,0,64,.15);
          animation:mf-toast-in .35s cubic-bezier(.16,1,.3,1) both;
          max-width:340px;
        }
        .mf-toast--success { background:#f0fdf4;color:#16a34a;border:1px solid #bbf7d0; }
        .mf-toast--error   { background:#fef2f2;color:#dc2626;border:1px solid #fecaca; }
        .mf-toast--warning { background:#fffbeb;color:#b45309;border:1px solid #fde68a; }

        /* ── Responsive ── */
        @media(max-width:1024px) {
          .mf-page { padding:22px 24px 60px; }
        }
        @media(max-width:768px) {
          .mf-page { padding:16px 16px 52px;gap:16px; }
          .mf-grid-2 { grid-template-columns:1fr; }
          .mf-date-range { flex-direction:column; }
          .mf-range-sep { transform:rotate(90deg); }
          .mf-submit-bar { flex-direction:column;align-items:stretch; }
          .mf-save-btn { justify-content:center; }
          .mf-section-body { padding:18px 18px 22px; }
          .mf-section-header { padding:16px 18px 14px; }
          .mf-marquee-add { flex-direction: column; }
          .mf-btn-secondary { width: 100%; justify-content: center; }
        }
      `}</style>
    </App>
  );
};

export default MetadataForm;